var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "#FEDC74",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "",
    clipRule: "",
    d: "M16.7628 7.04769L15.1014 2.13884C14.8566 1.41573 13.8339 1.41572 13.5891 2.13884L11.9277 7.04769C11.3791 8.66857 9.85831 9.75938 8.14711 9.75938H2.98521C2.20405 9.75938 1.88785 10.7655 2.52854 11.2124L6.53417 14.0062C7.99048 15.022 8.60069 16.8776 8.03146 18.5594L6.46215 23.1961C6.21516 23.9258 7.04304 24.5474 7.67492 24.1067L12.062 21.0468C13.4338 20.09 15.2567 20.09 16.6286 21.0468L21.0156 24.1067C21.6475 24.5474 22.4754 23.9258 22.2284 23.1961L20.659 18.5594C20.0898 16.8776 20.7 15.022 22.1563 14.0062L26.162 11.2124C26.8027 10.7655 26.4865 9.75938 25.7053 9.75938H20.5434C18.8322 9.75938 17.3114 8.66856 16.7628 7.04769ZM16.6136 1.62701C15.8794 -0.54234 12.8111 -0.542336 12.0769 1.62702L10.4155 6.53586C10.0863 7.50839 9.17383 8.16288 8.14711 8.16288H2.98521C0.641748 8.16288 -0.306885 11.1812 1.61522 12.5218L5.62085 15.3157C6.49463 15.9251 6.86076 17.0385 6.51923 18.0476L4.94991 22.6842C4.20895 24.8735 6.69258 26.7384 8.58824 25.4162L12.9753 22.3563C13.7984 21.7822 14.8921 21.7822 15.7152 22.3563L20.1023 25.4162C21.9979 26.7384 24.4816 24.8735 23.7406 22.6842L22.1713 18.0476C21.8298 17.0385 22.1959 15.9251 23.0697 15.3157L27.0753 12.5218C28.9974 11.1812 28.0488 8.16288 25.7053 8.16288H20.5434C19.5167 8.16288 18.6042 7.50839 18.275 6.53586L16.6136 1.62701Z",
    fill: "#FEDC74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/Star 2.0c5a27df0c72fe416e30606676f5ec0b.svg";
export { ForwardRef as ReactComponent };